import {
  resolveDynamicFlag,
  useDynamicFlag,
} from "@/utils/featureFlagOverride";

// Placement note: this lives under `features/` rather than beside
// `routes/_auth/genlab.$siteId/route.tsx` to match the repo's per-feature flag
// convention (`features/Audiences/flag.ts`, `features/Settings/flag.ts`).
// That is the only reason — the TanStack route generator handles non-route
// files in a route directory fine (it warns "does not export any route piece"
// and emits nothing, as it already does for the .stories.tsx files sitting in
// the genlab route directory).
const GENLAB_FLAG_KEY = "VITE_FF_ENABLE_GENLAB";
const genlabEnvValue = import.meta.env.VITE_FF_ENABLE_GENLAB === "true";

/**
 * GenLab must be *hidden in production*, not merely hidden-by-default, so the
 * dynamic override is ANDed with the env value: it can only ever turn GenLab
 * OFF, never on.
 *
 * - staging (env true): the Settings -> Feature Flags toggle still works as a
 *   kill-switch.
 * - production (env false): no localStorage override can opt back in, so the
 *   gate fails closed even with devtools open.
 *
 * `import.meta.env.PROD` is NOT a usable discriminator here — staging is also
 * a production build, so `genlabEnvValue` is the only thing separating the two.
 */
export const isGenLabEnabled = () =>
  genlabEnvValue && resolveDynamicFlag(GENLAB_FLAG_KEY, genlabEnvValue);

export const useIsGenLabEnabled = () => {
  // Called unconditionally (rules of hooks); the env gate is applied after.
  const overrideValue = useDynamicFlag(GENLAB_FLAG_KEY, genlabEnvValue);
  return genlabEnvValue && overrideValue;
};
